import { createSelector } from 'reselect';

import { selectIsPhoneConfirmed } from '@r1-frontend/entities/ContactDetail/selectors/selectIsPhoneConfirmed';

import { TState } from '~/src/store';

const getStateForContactsButton = createSelector(
    [
        selectIsPhoneConfirmed,
        (state: TState) => state.contactDetails.editedPhone.length < 11,
    ],
    (isPhoneConfirmed, isConfirmButtonDisabled) => ({
        isPhoneConfirmed,
        disabled: isConfirmButtonDisabled,
    }),
);

export default getStateForContactsButton;
